define(["exports", "react"], function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = useRovingTabIndex;

  function useRovingTabIndex(initialKey) {
    var keyCodes = Object.freeze({
      END: 35,
      HOME: 36,
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40
    });
    var refMap = (0, _react.useRef)(new Map()).current;

    var _useState = (0, _react.useState)([]),
        refKeys = _useState[0],
        setRefKeys = _useState[1];

    var _useState2 = (0, _react.useState)(initialKey),
        currentKey = _useState2[0],
        setCurrentKey = _useState2[1];

    (0, _react.useEffect)(function () {
      if (refMap.get(currentKey) === undefined) {
        var nextKey = refKeys[refKeys.indexOf(currentKey) + 1];

        if (nextKey) {
          setCurrentKey(nextKey);
        }
      }

      setRefKeys([].concat(refMap.keys())); // temp
    }, [refKeys, refMap, currentKey]);

    var moveFocus = function moveFocus(i) {
      setCurrentKey(refKeys[i]);
      refMap.get(refKeys[i]).focus();
    };

    var moveFocusToPreviousSibling = function moveFocusToPreviousSibling(i) {
      return moveFocus(i - 1);
    };

    var moveFocusToNextSibling = function moveFocusToNextSibling(i) {
      return moveFocus(i + 1);
    };

    var moveFocusToFirstSibling = function moveFocusToFirstSibling() {
      return moveFocus(0);
    };

    var moveFocusToLastSibling = function moveFocusToLastSibling() {
      return moveFocus(refKeys.length - 1);
    };

    var handleKeyDown = function handleKeyDown(event, key) {
      var keyCode = event.keyCode;
      var i = refKeys.indexOf(key);

      if (Object.values(keyCodes).includes(keyCode)) {
        event.preventDefault();
      }

      switch (keyCode) {
        case keyCodes.UP:
        case keyCodes.LEFT:
          if (i === 0) {
            return moveFocusToLastSibling();
          }

          return moveFocusToPreviousSibling(i);

        case keyCodes.DOWN:
        case keyCodes.RIGHT:
          if (i === refKeys.length - 1) {
            return moveFocusToFirstSibling();
          }

          return moveFocusToNextSibling(i);

        case keyCodes.HOME:
          return moveFocusToFirstSibling();

        case keyCodes.END:
          return moveFocusToLastSibling();

        default:
          return;
      }
    };

    var handleClick = function handleClick(key) {
      var i = refKeys.indexOf(key);
      moveFocus(i);
    };

    return {
      refMap: refMap,
      handleKeyDown: handleKeyDown,
      handleClick: handleClick,
      currentKey: currentKey
    };
  }
});